module.exports = __webpack_public_path__ + "media/images/lb/074-053259d9ff9be5c447f2477f6ad21f93.svg";